import axios from 'axios';

// const csrfToken = getCookie('XSRF-TOKEN');

// Crear instancia de Axios

export const apiClient = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
    withCredentials: true
});

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

apiClient.interceptors.request.use(config => {
  // const csrfToken = getCookie('access_token_cookie');

  config.withCredentials = true;

  const csrfToken = getCookie('csrf_access_token');

  if (csrfToken) {
    config.headers['X-CSRF-TOKEN'] = csrfToken;
  }
  return config;
});


apiClient.interceptors.response.use(
  response => response, // ✅ respuesta exitosa
  async error => {
    const originalRequest = error.config;
    // console.log(originalRequest, "status",error.response?.status, error.response?.status === 401,
    //   !originalRequest._retry,
    //   !originalRequest.url.includes('/login') );
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url.includes('/login') 
      && !originalRequest.url.includes('/refresh')
    ) {
      originalRequest._retry = true;
      try {
        await apiClient.get('/refresh', { withCredentials: true });
        return apiClient(originalRequest); // ✅ reintenta la solicitud original
      } catch (refreshError) {
        // console.error('Refresh token failed:', refreshError);
        localStorage.setItem('verifiedLogin', false);
        localStorage.removeItem('verifiedLogin')
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);


// Interceptor de solicitudes
// apiClient.interceptors.request.use(
//     async (config) => {
//         let token = localStorage.getItem('access_token');

//         // Verifica si el token está cerca de expirar
//         if (token && isTokenExpired(token)) {
//             try {
//                 // Obtener nuevo token usando refresh token
//                 token = await refreshAccessToken();
//                 localStorage.setItem('access_token', token);
//             } catch (error) {
//                 console.error('Error refrescando el token:', error);
//                 // Manejo de error: redireccionar a la página de login si el refresh falla
//                 window.location.href = '/login';
//             }
//         }
//         // Agregar el token a los headers de la solicitud
//         config.headers.Authorization = `Bearer ${token}`;
//         return config;
//     },
//     (error) => {
//         return Promise.reject(error);
//     }
// );

// axios.interceptors.response.use(
//     res => res,
//     async error => {
//         const originalRequest = error.config;
//         console.log(error.response?.status === 401, !originalRequest._retry, !originalRequest.url.includes('/login'), error.response?.status === 401, !originalRequest._retry,!originalRequest.url.includes('/login'));
        
//         if (error.response?.status === 401 && !originalRequest._retry && !originalRequest.url.includes('/login')) {
//             originalRequest._retry = true;
//             try {
//                 await axios.post('/api/refresh', {}, { withCredentials: true });
//                 return axios(originalRequest);
//             } catch (refreshError) {
//                 window.location.href = '/login';
//             }
//         }
//         return Promise.reject(error);
//     }
// );

// function getCookie(name) {
//   const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
//   return match ? decodeURIComponent(match[2]) : null;
// }


// Función que verifica si el token ha expirado
const isTokenExpired = (token) => {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const expiry = (payload.exp * 1000);
    const now = new Date().getTime();

    const timeRemaining = expiry - now;
    // console.log("validate time", timeRemaining <= 60000 , timeRemaining > 0, timeRemaining <= 60000 && timeRemaining > 0);
    // console.log("diference", timeRemaining, expiry, now);
    if(timeRemaining < 0){
        localStorage.clear();
        window.location.href = '/'
    }
    return timeRemaining < 60000 ;
};

// Función para refrescar el access token
const refreshAccessToken = async () => {
//   const refreshToken = localStorage.getItem('refresh_token');
    const response = await axios.get('/refresh');
    
    if (response.data.access_token) {
        return response.data.access_token;
    } else {
        throw new Error('Error obteniendo nuevo access token');
    }
};
